import { render, staticRenderFns } from "./PlushieAutocompleteItem.vue?vue&type=template&id=2a4403dd&"
import script from "./PlushieAutocompleteItem.vue?vue&type=script&lang=ts&"
export * from "./PlushieAutocompleteItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports